<template>
    <div class="comp__table-product-options">
        <ProductOptions
            :key="product"
            :product="product"
            :isImageTypeSwatch="true"
            :selectedOptions="getProductForm(product)"
            @on-option-change="(key, value, index, length) => onOptionChange(key, value, index, length, pIndex)"
        />
        <CompareTableProductATC
            :product="product"
            :getProductForm="getProductForm"
        />
    </div>
</template>

<script setup>
import ProductOptions from '../../pdp-first-fold/components/product-options/index.vue';
import CompareTableProductATC from './compare-table-product-atc.vue';

defineProps({
    pIndex: Number,
    product: Object,
    redirectToBottom: Function,
    getProductForm: Function,
    onOptionChange: Function
});

</script>
